package com.macrofocus.nastac

class NASTAC {
    val dataLoader = DataLoader()
}